import { render, staticRenderFns } from "./FractionalNumericEntry.vue?vue&type=template&id=20ad2860&scoped=true&"
import script from "./FractionalNumericEntry.vue?vue&type=script&lang=js&"
export * from "./FractionalNumericEntry.vue?vue&type=script&lang=js&"
import style0 from "./FractionalNumericEntry.vue?vue&type=style&index=0&id=20ad2860&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ad2860",
  null
  
)

export default component.exports